module.exports = __webpack_public_path__ + "assets/img/icon_delete.44976635.svg";